import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private messageService: MessageService) { }
  
  notificacionError(detalles: string) {
    this.messageService.add({ severity: 'error', summary: 'Error!', detail: detalles });
  }
  notificacionSuccess(detalles: string) {
    this.messageService.add({ severity: 'success', summary: 'Confirmado!', detail: detalles });
  }
}
